module.exports = __webpack_public_path__ + "img/472.d33ed5c6.png";